import { ConcreteEncodable } from "./ConcreteEncodable";

import { InflightCheckEventImplEncoder } from "../../encoder/InflightCheckEventImplEncoder";

import * as CubiqTS from "../../index";
import { InflightCheckEvent } from "../InflightCheckEvent";

export class InflightCheckEventImpl extends ConcreteEncodable implements InflightCheckEvent {
  public static enType: string = "com.bcdfx.model.event.InflightCheckEventImpl";

  /*FID=1*/
  public ruleId: CubiqTS.Long | null = null;
  /*FID=2*/
  public ruleName: string;
  /*FID=3*/
  public ruleType: CubiqTS.InflightRuleType;
  /*FID=4*/
  public ruleRangeValue: string;
  /*FID=5*/
  public ruleRateUnits: string;
  /*FID=6*/
  public isCancelOutrightFg: boolean;
  /*FID=7*/
  public alternateTraderGroup: CubiqTS.TradingGroup | null = null;
  /*FID=8*/
  public actionType: CubiqTS.InflightActionType;
  /*FID=9*/
  public orderData: CubiqTS.OrderData | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = InflightCheckEventImplEncoder.Instance;
    this.setEncodableType(InflightCheckEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "InflightCheckEventImpl[" +
      "ruleId=" +
      this.ruleId +
      "ruleName=" +
      this.ruleName +
      "ruleType=" +
      this.ruleType +
      "ruleRangeValue=" +
      this.ruleRangeValue +
      "ruleRateUnits=" +
      this.ruleRateUnits +
      "isCancelOutrightFg=" +
      this.isCancelOutrightFg +
      "alternateTraderGroup=" +
      this.alternateTraderGroup +
      "actionType=" +
      this.actionType +
      "orderData=" +
      this.orderData +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
